import { render } from "./ForgotPassword.vue?vue&type=template&id=e04ce1e2&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=e04ce1e2&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/ecstatic-ride.91-210-227-178.plesk.page/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04ce1e2"]])

export default __exports__